module.exports = __webpack_public_path__ + "img/456-fbc5de.png";